import React from 'react';
import { Link } from 'react-router-dom';
import { LanguageToggle } from './LanguageToggle';
import { Logo } from './LogoWhite';
export function Navbar() {
  return <nav className="bg-[#022a3b] py-4 px-4 md:px-8 border-b border-[#003b54]" data-id="element-138">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-139">
        <Link to="/" className="flex items-center gap-2 text-white font-bold text-2xl tracking-tight" data-id="element-140">
          <Logo width={100} data-id="element-141" />
        </Link>
        <div className="flex items-center gap-6" data-id="element-142">
          <a href="https://vitau.mx" className="hidden md:block text-sm text-white/80 hover:text-white transition-colors" data-id="element-143">
            Ir a vitau.mx
          </a>
          <LanguageToggle data-id="element-144" />
        </div>
      </div>
    </nav>;
}